module.exports = __webpack_public_path__ + "static/img/multi-channel.901b388.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/mobile/multi-channel.png
// module id = SZNQ
// module chunks = 12